import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Starts Add product's queue for the products the native scanner found: each
// goes through When and How often in turn (see NewRoutineProductPage). The
// queue's When URL comes from the server with a QUEUE placeholder, so it's
// built exactly as the server builds it later, which is how the native
// navigator recognizes it to go back to.
export default class extends Controller {
  static values = { queueUrl: String, frame: String }

  startQueue(event) {
    if (event.detail?.status !== "completed") return

    const ids = Array.from(event.detail.products || [])
      .map((product) => Number(product.product_id || product.productId))
      .filter((id) => id > 0)
    const queue = [ ...new Set(ids) ]
    if (queue.length === 0) return

    const url = this.queueUrlValue.replace("QUEUE", encodeURIComponent(queue.join(",")))
    Turbo.visit(url, this.frameValue === "_top" ? {} : { frame: this.frameValue })
  }
}
